import React from 'react';
import CSLTable from './CSLTable';
import AdvanceFilter from './AdvanceFilter';
import CSLReportModal from './CSLReportModal';
import PdfGenerator from './PdfGenerator';
import Store from '../../../Common/Store';
import Utils from '../../../Common/Utils.js';
import styled from 'styled-components';


const InactiveOverlay = styled.div`
	display: block;
	box-sizing: border-box;
	height: calc(100vh-200px);
	width: 100%;
	background-color: #ffffff;
	position: absolute;
	z-index: 1000;
	opacity: 0.8;
	top: 0px;
`;



class FaqRegisterReporting extends React.Component
{
	state = {
				show_filter: true, 
				filters: null, 
				pill_filters: null, 
				show_report: false, 
				generate: false, 
				groupby_selections: [], 
				sortby_selected: {accessor: 'none', order: 'Descending'},
				tilte_pdf : null,
				orientation:'portrait'
			}

	data = {};

	constructor(props) {
    	super(props);
    	this.scrollDiv = React.createRef();
  	}

  	setComponentState = () => {
  		let filters = this.state.filters === null ? this.props.filters : this.state.filters
      // console.log("filters", filters)
  		let pill_filters = this.state.pill_filters === null ? this.props.pillFilters : this.state.pill_filters
  		let grouping_config = Store.getStoreData('groupings')
  		let tags_config = grouping_config.tags_config
  		let groupings = {}
  		let data = this.props.data
      console.log('this.state.filters', data)
  		for(let t of tags_config) {
  			let id = Object.keys(t)[0]
  			groupings[id] = t[id]
    		let included = data.table_headers.filter(obj => {
  			  return obj.accessor === id
  			})
			// // console.log('setComponentState included', included)
  			if(included.length === 0)data.table_headers.push({accessor: id, nickname: t[id], type: 'alpha', width: 0})
  			included = data.groupby.fields.filter(obj => {
  			  return obj.accessor === id
  			})
  			if(included.length === 0)data.groupby.fields.push({accessor: id, nickname: t[id]})
  			included = data.sortby.fields.filter(obj => {
  			  return obj.accessor === id
  			})
  			if(included.length === 0)data.sortby.fields.push({accessor: id, nickname: t[id]})

  			if(!(id in filters))filters[id] = {name: id, nickname: t[id], options: {}, selections: {}, size: 2, type: 'multi', is_grouping: true}
        let applied_filters = Store.getStoreData('applied_filters')
        if(applied_filters !== null)filters[id].selections = applied_filters[id].selections
  		}
  	
      let table_data = this.generateTableData()

  		for(let r of table_data.raw_data) {
  			for(let id in filters) {
  				if(!(r[id] in filters[id].options)) {
  					filters[id].options[r[id]] = {name: r[id]}
  				}
  			}
  		}
  		let tilte_pdf = this.props.titlePDF === undefined ? '' : this.props.titlePDF;
  		let orientation = this.state.orientation === null ? this.props.orientation : this.state.orientation;

  		this.setState({filters, pill_filters, data, groupings, tilte_pdf, orientation})
  	}



  	componentDidMount() {
  		this.setComponentState()
  	}

  	componentDidUpdate(prevprops) {
  		if(prevprops === this.props)return

  		this.setComponentState()
  	}

	clearAdvancedFilter = () => {
		// window.location.reload()
		this.props.refreshCallback()
	}
	applyFilter = (filters) => {
		let applied_filters = JSON.parse(JSON.stringify(filters))
        // if ((filters).length === 0) return false;
        // console.log('applyAdvancedFilterDate filters', filters)
        // // // console.log('applyAdvancedFilterDate applied_filter', applied_filters)
        this.setState({filters: applied_filters})
        Store.updateStore('applied_filters', applied_filters)
        this.props.refreshCallback()
	}



	setShowTable = (flag, table) => {
	  this.props.setShowTable(flag, table);
	}

	toggleConfigureReport = (event) => {
		let show_configure_report = false;
		show_configure_report = show_configure_report === true ? false : true;
		this.setState({show_configure_report});
	}

	hideReport = () => {
		this.setState({show_report: false});
	}

	toggleGenerate = () => {
		let generate = this.state.generate ? false : true;
		this.setState({generate});
	}

	reportCallback = () => {
		this.setState({show_report: true})
	}

	changeSort = (sortby) => {
        let data = JSON.parse(JSON.stringify(this.state.data));
        this.data.sortby = sortby;
        this.setState({data: this.data, sortby_selected: sortby.selected});
	}

	changeGroup = (groupby) => {
        let data = JSON.parse(JSON.stringify(this.data));
        this.data.groupby = groupby;
        this.setState({data: this.data, groupby_selections: groupby.selections});
	}

    pillClickHandler = (event) => {
        event.preventDefault();
        
        let pill_id = [event.target.name]
        let pill_filters = this.state.pill_filters;
        pill_filters[pill_id].is_active = (pill_filters[pill_id].is_active + 1) % 2
        this.setState({pill_filters})
        this.props.refreshCallback()
    }

    filterDateScore = (date) => {
    	// // // console.log('applyAdvancedFilterDate, date', date)
    	let date_parts = date.split('T')[0].split('-')
    	return parseInt(date_parts[0]) * 10000 + parseInt(date_parts[1]) * 100 + parseInt(date_parts[2])
    }
    tableDateScore = (date) => {
    	let date_parts = date.split('/')
    	return parseInt(date_parts[2]) * 10000 + parseInt(date_parts[1]) * 100 + parseInt(date_parts[0])
    }

    filterRow = (elem) => {
    	let filters = this.state.filters
    	let inclusion = 1
    	console.log('applyAdvancedFilterDate filters, elem', filters, elem)
    	for(let id in filters) {
    		if(Object.keys(filters[id].selections).length === 0) {
    			inclusion *= 1
    		} else {
    			switch(filters[id].type) {
    				case 'text' : inclusion *= elem[id].toLowerCase().includes(filters[id].selections.text.toLowerCase()) ? 1 : 0; break;
    				case 'multi' : 
    				case 'single' : inclusion *= (elem[id] in filters[id].selections ? 1 : 0); break;
    				case 'date_range' : let from_date = this.tableDateScore(filters[id].selections.from_date)
    									let to_date = this.tableDateScore(filters[id].selections.to_date)
    									let table_date = this.tableDateScore(elem[id])
    									// // console.log('applyAdvancedFilterDate, from_date, to_date, table_date', from_date, to_date, table_date)
    									inclusion *= (table_date >= from_date && table_date <= to_date) ? 1 : 0; break;
    			}
    		}
    	}
// row.answer.toLowerCase().search(filters.answer.selections.text.toLowerCase()) >= 0
    	return (inclusion > 0)
    }

    getInclusion = (row_filter) => {
    	let pill_filters = this.state.pill_filters
    	// // console.log('getInclusion pill_filters, row_filter', pill_filters, row_filter)

    	let included_count = 0
    	/*for(let pid in pill_filters) {
    		included_count += pill_filters[pid].is_active * row_filter[pid]
    	}*/

    	return (included_count > 0)
    }

    generateTableData = () => {
    	let data = this.props.processTableData()
    	let groupings = Store.getStoreData('groupings')
    	let gc_assoc = Store.getStoreData('gc_assoc')
    	let grouping_tags = {}
  		for(let t of groupings.tags_config) {
  			let id = Object.keys(t)[0]
  			grouping_tags[id] = t[id]
  		}
    	let tags = {}
    	for(let id in groupings.tags) {
    		tags[id] = {}
    		for(let g of groupings.tags[id]) {
    			tags[id][g.id] = g.name
    		}
    	}
    	// console.log('generateTableData gc_assoc', data.raw_data)
    	for(let r of data.raw_data) {
    		let company_id = (parseInt(r.company_id) % 100000).toString()
    		let gc_grouping = (company_id in gc_assoc && 'tags_config' in gc_assoc[company_id]) ? gc_assoc[company_id].tags_config : {}
    		// // // console.log('generateTableData gc_grouping', gc_grouping)
    		for(let tid in grouping_tags) {
    			if(tid in gc_grouping && tid in tags) {
    				if(gc_grouping[tid] in tags[tid]) {
    					r[tid] = tags[tid][gc_grouping[tid]]
    				} else {
    					r[tid] = 'None'
    				}
    			} else {
    				r[tid] = 'None'
    			}
    		}
    	}
    	// // // console.log('generateTableData data.raw_data', data.raw_data)
    	let ret = {columns: data.columns, data: [], raw_data: [], row_filters: data.row_filters} 

    	for(let elem of data.raw_data) {
			if(this.filterRow(elem)){
				if(this.getInclusion(data.row_filters[elem.id])) {
				  	ret.data.push(elem);
				}
        ret.data.push(elem);
				ret.raw_data.push(elem);
			}    		
    	}

    	return ret
    }

    goToReport = () => {
    	this.setState({show_report: true})
    }

    showOnlyAssign = (flag) =>{
      this.props.showOnlyAssign(flag);
    }

    setShowTable = (flag, table) => {
      this.props.setShowTable(flag, table);
    }

	toggleOrientation = (mode) => {
    	this.setState({orientation: mode});
  	}


	render()
	{
		
		if(this.state.filters === null) return <div></div>

		
		return (
			<div style={{position: "relative", backgroundColor: "#F2F2F2", padding: "10px 0px"}} ref={this.scrollDiv}>
				<div style={{clear: "both", height: '3px'}}></div>
				<div style={{clear: "both"}}></div>

				<AdvanceFilter 
					filters={this.state.filters} 
					applyFilter={this.applyFilter} 
					clearAdvancedFilter={this.clearAdvancedFilter}
				/>
				<CSLTable export={true}  goToReport={this.goToReport} export_file_name={"RegisterFAQ"}  
							add={false}  
							processData={this.generateTableData} 
							prefered_columns = {this.props.preferedColumns} 
							headerText={this.props.headerText} 
              HeaderFilter={this.props.HeaderFilter}
							tableRows={10} 
							refreshCallback={this.refreshCallback} 
							report={true}
              show_filter={this.props.show_filter}
              table={this.props.table}
              export={true}
              setShowTable={this.setShowTable}

				/>           

				{
					(() => {
						if(this.state.show_report) {
							let fields = this.props.fields
							let data = this.props.data
							data.data = this.generateTableData().data
							return (
									<div style={{position:'absolute', top:'0px', width:'100%'}}>
										<InactiveOverlay />
										<CSLReportModal
											data={data}
											changeSort={this.changeSort}
											changeGroup={this.changeGroup}
											hideReport={this.hideReport}
											toggleGenerate={this.toggleGenerate}
											filters={this.state.filters}
											toggleOrientation={this.toggleOrientation}
										/>
									</div>
								);
						}
					})()
				}
				{
					(() => {
						if (this.state.generate) {
							return (
								<div style={{position:'absolute', top:'10px', width:'calc(100%-50px)', height: 'calc(100vh-90px)'}}>
									<InactiveOverlay style={{zIndex: "1010"}} />
									<PdfGenerator 
									filters={this.state.filters} 
									pills={this.state.pill_filters} 
									toggleGenerate={this.toggleGenerate} 
									contactName={Store.getStoreData('contact')} 
									tiltePDF={this.state.tilte_pdf}
                    				orientation={this.state.orientation}
									/>
								</div>
							);
						}
					})()
				}
			</div>
		);
	}

	scrollToMyRef = () => this.scrollDiv.current.scrollIntoView({ behavior: 'smooth' });
}

export default FaqRegisterReporting;

